<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <!-- <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryCaseName"
          style="margin-bottom:-20px !important;"
          class="v-offset-none"
          color="purple"
          icon="mdi-folder-open"
          title="案名"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryDate"
          style="margin-bottom:-20px !important;"
          color="indigo"
          icon="mdi-calendar"
          title="資料日期"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryEMS"
          style="margin-bottom:-20px !important;"
          color="light-blue"
          icon="mdi-factory"
          title="EMS"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(responseAreaData.failRate * 100).toFixed(1) + '%'"
          :class="responseAreaData.warningColor || 'green'"
          :color="responseAreaData.color"
          :icon="responseAreaData.icon || 'mdi-check'"
          class="title-color"
          style="margin-bottom:-20px !important;"
          title="Fail Rate"/>
      </v-flex> -->
      <v-flex
        class="v-flex__first"
        style="margin-top: 55px !important;"
        xs12>
        <material-card
          class="v-flex v-c3-chart"
        >
          <div
            class="chart-btn c3-chart c3-click"
            style="margin-top: -3.5rem!important;width:100%;">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              ErrorCode统计图
              <div class="float-right">
                                <!-- <v-btn
                  v-for="(mode,m) in calibrationModeMenu"
                  :key="'m'+m"
                  class="black text-light mr-0 ml-2 px-2"
                  @click="calibrationMode=mode">{{ mode }}</v-btn> -->
              </div>
              <p class="m-0">Factory：{{ propData.factoryName }} ｜ Project：{{ propData.modelName }} ｜ Type：{{ propData.ohmType }}｜ Time Interval：{{ propData.startTime }} ~ {{ propData.endTime }}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
            <!-- <vue-c3 :handler="handler_bar"/> -->
            <div id="fyzchart" ref="chartContainer" ></div>
             <div id="custom-legend" :class="`app-theme-${theme}`"  style="text-align:center; margin-top:10px;"></div>
          </div>
          <!-- <div>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;">
              <v-autocomplete
                v-model="xRange"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                :items="[
                  { text: 0.01, value: 0.01 },
                  { text: 0.025, value: 0.025 },
                  { text: 0.05, value: 0.05 }
                ]"
                label="數值區間"
                class="v-text-field__slot v-text-field__details-none"
                persistent-hint
                outlined
              />
            </v-flex>
            <material-notification
              :class="{'text-white' : theme==='dark' , 'text-body' : theme==='light'}"
              :color="theme==='dark'?'black':'white'"
              class="mt-1 py-1 mb-1 h4 font-weight-bold"
            >
              <v-card-title
                primary-title
                class="mt-0 px-0 py-0 d-block text-center">
                <div class="headline m-auto">
                  <h6 class="my-0 text-left">Max</h6>
                  <h2 class="my-0 text-right">{{ Max.value.toFixed(2) }}</h2>
                  <hr class="my-3 white">
                  <h6 class="my-0 text-left">Avg</h6>
                  <h2 class="my-0 text-right">{{ Avg.value.toFixed(2) }}</h2>
                  <hr class="my-3 white">
                  <h6 class="my-0 text-left">Min</h6>
                  <h2 class="my-0 text-right">{{ Min.value.toFixed(2) }}</h2>
                </div>
              </v-card-title>
            </material-notification>
          </div> -->
        </material-card>
        <div v-if="showtable === true">
              <material-notification
              color="brown"
              class="mt-1 py-1 mb-1 h4 font-weight-bold"
            >
               <div style="display: flex; align-items: center; justify-content: space-between; height: 100%;">

    <!-- 左侧文字（左中） -->
    <p style="margin: 0;">
      ErrorCode: {{ clicktitle }}
    </p>

    <!-- 右侧 select -->
     <div style="width: 90px;">
      <v-select
        v-model="pagination.current.rowsPerPage"
        :class="{'danger-input' : theme==='dark', 'general-input' : theme==='light'}"
        :items="rowsAmount"
        persistent-hint
        outlined
        :menu-props="{ maxWidth: '90px', offsetX: true }"
      />
    </div>
  </div>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
 <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">
        <v-data-table
          :headers="[
            { text: 'ISN', value: 'isn' ,class: 'table-width-150',sortable: true},
            { text: 'factoryname', value: 'factoryName' ,class: 'table-width-185',sortable: true},
            { text: 'Starttime', value: 'startTime' ,class: 'table-width-185',sortable: true},
            { text: 'Endtime', value: 'endTime' ,class: 'table-width-185',sortable: true},
            { text: 'code90', value: 'code90' ,class: 'table-width-100',sortable: true},
            { text: 'modelname', value: 'modelName' ,class: 'table-width-125',sortable: true},
            { text: 'ToolName', value: 'toolName' ,class: 'table-width-150',sortable: true},
            { text: 'ToolVer', value: 'toolVer' ,class: 'table-width-100',sortable: true},
            { text: 'ErrorCode', value: 'errorCode' ,class: 'table-width-110',sortable: true}
          ]"
          :items="responseData"
          :pagination.sync="pagination.current"
          :rows-per-page-items="rowsAmount"
          :class="{ 'showList': true}"
          class="freeze-title height-row-3"
                      multi-sort
            hide-actions
        >
         <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                 <td class="table-width-150">{{ item.isn }}</td>
                <td class="table-width-185">{{ item.factoryName }}</td>
                <td class="table-width-185">{{ item.startTime }}</td>
                <td class="table-width-185">{{ item.endTime }}</td>
                <td class="table-width-100">{{ item.code90 }}</td>
                <td class="table-width-125">{{ item.modelName }}</td>
                <td class="table-width-150">{{ item.toolName }}</td>
                <td class="table-width-100">{{ item.toolVer }}</td>
                <td class="table-width-110">{{ item.errorCode }}</td>
              </tr>
            </template>
        </v-data-table>
        <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
      </material-card>
      </div>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
// import VueC3 from 'vue-c3'
import * as c3 from 'c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'ShowLcdCalibrationGammaDiffBarChart',
  components: {

  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      test: [],
      // lcdFilterUpdateTime: '',
      Min: {
        value: 0
      },
      Max: {
        value: 0
      },
      Avg: {
        value: 0
      },
      RangeMin: 0,
      RangeMax: 9999,
      RangeMinLimit: 0.01,
      RangeMaxLimit: 0.05,
      xRange: 0.025,
      LessRangeCount: {
        value: 0
      },
      OverRangeCount: {
        value: 0
      },
      chart: null,
      // RangeCount: 1,
      responseAreaData: [],
      barXaxisItem: ['value'],
      barXaxisItemName: ['Gamma Diff'],
      barXaxisName: [],
      barXaxisValue: [],
      handler_bar: new Vue(),
      selectedBar: null, // 存儲選中的索引
      showTable: false, // 控制表格顯示
      responseData: [], // 存儲表格數據
      newData: [],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          totalItems: 0
        }
      },
      isSorting: false,
      ClickIndex: 0,
      ClickName: '',
      pages: 4,
      xAxis: Array.from({ length: 11 }, (_, i) => (0.9 + i * 0.01).toFixed(2)),
      ResultHistogram: {},
      SRGBHistogram: {},
      P3Histogram: {},
      rowsAmount: [10, 25, 50, 100],
      IsSubmitPage: true,
      showtable: false,
      clicktitle: ''

    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    },
    options_bar () {
      const pieColumns = this.responseAreaData.map(item => {
        return [item.errorCode, item.count]
      })
      const legendNames = {}
      this.test.forEach(item => {
        legendNames[item.errorCode] = `${item.errorCode} (${item.count})`
      })
      const total = this.responseAreaData.reduce((sum, x) => sum + x.count, 0)
      console.info(pieColumns)
      console.info(total)
      return {
        data: {
          columns: pieColumns,
          labels: true,
          type: 'pie', // 设置为饼图
          names: legendNames,
          onclick: (d, element) => {
            console.info('所有', d) // 记录点击的 X 轴索引
            console.info('点击的索引：', d.index) // 记录点击的 X 轴索引
            console.info('点击的数据列：', d.name) // 记录点击的 Y 轴数据列名
            console.info('点击的数据值：', d.value) // 记录点击的数值
            console.info('DOM 元素：', element) // 获取点击的 DOM 元素

            this.ClickIndex = d.index // 记录点击的索引
            this.ClickName = d.name // 记录点击的系列名称
            this.ClickValue = d.value
            this.showTable = true // 显示表格
            this.loadTableData(d.index, d.name, d.value) // 根据索引和系列名加载表格数据
          }
        },
        // axis: {
        //   x: {
        //     type: 'category', // 使用分类类型
        //     tick: {
        //       rotate: -45,
        //       multiline: false
        //     }
        //   },
        //   y: {
        //     label: {
        //       text: '数量（*.xml）',
        //       position: 'outer-middle'
        //     }
        //   }
        // },
        tooltip: {
        // ===== 3. 自定义 tooltip（可按你喜好修改） =====
          contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
            const id = d[0].id
            const value = d[0].value

            return `
      <table class="c3-tooltip">
        <tbody>
          <tr><td>ErrorCode:</td><td>${id}</td></tr>
          <tr><td>数量:</td><td>${value}</td></tr>
        </tbody>
      </table>
      `
          }
        },
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        pie: {
          label: {
            format: (value, ratio, id) => {
              const percent = (value / total * 100).toFixed(1) + '%'
              return `${id} (${value})\n${percent}`
            }
          }
        },
        legend: {
          position: 'bottom',
          padding: 16
        },
        size: {
          height: 600
        }
      }
    }
  },
  watch: {
    pagination: {
      handler (newName, oldName) {
        if (this.IsSubmitPage) {
          return
        }
        const start = (this.pagination.page - 1) * this.pagination.current.rowsPerPage
        const end = start + this.pagination.current.rowsPerPage
        console.info(this.newData.slice(start, end))
        this.responseData = this.newData.slice(start, end)
      },
      immediate: true,
      deep: true
    },
    'pagination.current.sortBy' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        // 让排序锁在本次事件循环后释放
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.current.descending' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.page': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.showtable && !this.IsSubmitPage) {
          this.loadTableData(this.ClickIndex, this.ClickName, this.ClickValue)
        }
      },
      immediate: true,
      deep: true
    },
    'pagination.current.rowsPerPage': {
      handler (newName, oldName) {
        console.info('this.isSorting', this.isSorting)
        if (this.isSorting) return
        if (this.showtable && !this.IsSubmitPage) {
          this.pagination.page = 1
          this.loadTableData(this.ClickIndex, this.ClickName, this.ClickValue)
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.processingView = true
    this.$store.dispatch('getAuthorize', '/tpohm/TPImpedance/ShowErrorpieChart')
      .then(response => {
        console.info(response)
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cacheFilterInfo')
          if (cache) {
            // ✅ 優先用 sessionStorage 中的副本
            this.propData = JSON.parse(cache)
          } else {
            // ✅ 第一次從 localStorage 拿到後，存入 sessionStorage
            const raw = localStorage.getItem('tpohmFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cacheFilterInfo', raw)
            }
          }
          console.info('test')
          // this.lcdFilterUpdateTime = localStorage.getItem('lcdFilterUpdateTime')
          this.doSubmit('result')
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
        this.processingView = false
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    renderCustomLegend () {
      const legendContainer = document.getElementById('custom-legend')
      if (!legendContainer || !this.chart) return
      legendContainer.innerHTML = ''

      this.chart.data().forEach(d => {
        const color = this.chart.color(d)
        const span = document.createElement('span')
        const shownIds = this.chart.data.shown().map(s => s.id)
        const isVisible = shownIds.includes(d.id)
        span.style.margin = '0 10px'
        span.style.cursor = 'pointer'
        span.style.display = 'inline-block'
        span.className = 'legend-item' + (isVisible ? '' : ' disabled') // 加上 disabled 樣式

        const isBeforeCorrection = d.id.includes('校正前')
        const boxStyle = isBeforeCorrection
          ? `border: 2px solid ${color}; background-color: transparent;`
          : `background-color: ${color};`
        span.innerHTML = `
        <span style="${boxStyle} width:12px; height:12px; display:inline-block; margin-right:5px;"></span>
        <span>${d.id}</span>`

        span.addEventListener('click', () => {
          this.chart.toggle(d.id)
          const nowVisible = this.chart.data.shown().map(s => s.id).includes(d.id)
          if (nowVisible) {
            span.classList.remove('disabled')
          } else {
            span.classList.add('disabled')
          }
        })

        span.addEventListener('mouseover', () => {
          this.chart.focus(d.id)
          const allSpans = legendContainer.querySelectorAll('.legend-item')
          allSpans.forEach(el => {
            if (el !== span) {
              el.classList.add('legend-fade')
            }
          })
        })

        span.addEventListener('mouseout', () => {
          this.chart.revert()
          const allSpans = legendContainer.querySelectorAll('.legend-item')
          allSpans.forEach(el => {
            el.classList.remove('legend-fade')
          })
        })

        legendContainer.appendChild(span)
      })
    },
    doSummary (type) {
      this.ResultHistogram = {
        'resultNativeCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'resultNativeCoverageP3': new Array(this.xAxis.length).fill(0),
        'resultCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'resultCoverageP3': new Array(this.xAxis.length).fill(0)
      }
      this.SRGBHistogram = {
        'srgbNativeCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'srgbCoverageSRgb': new Array(this.xAxis.length).fill(0)
      }
      this.P3Histogram = {
        'p3NativeCoverageP3': new Array(this.xAxis.length).fill(0),
        'p3CoverageP3': new Array(this.xAxis.length).fill(0)
      }

      const processHistogram = (histogram, item) => {
        Object.keys(histogram).forEach(key => {
          const value = item[key]
          console.info(key)
          console.info(value)
          if (typeof value === 'number') {
            const bucketValue = Math.floor(value * 100) / 100 // 無條件捨棄至小數點後兩位
            console.info('bucketValue', bucketValue)
            // 只處理範圍在 0.9 到 1.0 之間的值
            if (bucketValue >= 0.9 && bucketValue <= 1.0) {
              const index = Math.round((bucketValue - 0.9) * 100) // 0.90 為 index 0，0.91 為 1，...，1.00 為 10
              if (histogram[key][index] !== undefined) {
                histogram[key][index]++
              }
            } else if (bucketValue < 0.9) {
              histogram[key][0]++ // 小於 0.90 歸為 index 0（或依照你定義的 fallback index）
            }
          }
        })
      }
      this.responseAreaData.forEach(item => {
        processHistogram(this.ResultHistogram, item)
        processHistogram(this.SRGBHistogram, item)
        processHistogram(this.P3Histogram, item)
      })
      // this.responseAreaData.forEach(item => {
      //   // 遍历第一组数据
      //   Object.keys(this.ResultHistogram).forEach(key => {
      //     const value = item[key]
      //     if (typeof value === 'number') {
      //       let index
      //       if (value < 0.9) {
      //         index = 0 // 0.00 - 0.90 归到索引 0
      //       } else if (value <= 1.0) {
      //         index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1) // 0.90 - 1.00 归到索引 1-10
      //       }
      //       if (index !== undefined) {
      //         this.ResultHistogram[key][index]++
      //       }
      //     }
      //   })

      //   // 遍历第二组数据
      //   Object.keys(this.SRGBHistogram).forEach(key => {
      //     const value = item[key]
      //     if (typeof value === 'number') {
      //       let index
      //       if (value < 0.9) {
      //         index = 0
      //       } else if (value <= 1.0) {
      //         index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1)
      //       }
      //       if (index !== undefined) {
      //         this.SRGBHistogram[key][index]++
      //       }
      //     }
      //   })

      //   // 遍历第三组数据
      //   Object.keys(this.P3Histogram).forEach(key => {
      //     const value = item[key]
      //     if (typeof value === 'number') {
      //       let index
      //       if (value < 0.9) {
      //         index = 0
      //       } else if (value <= 1.0) {
      //         index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1)
      //       }
      //       if (index !== undefined) {
      //         this.P3Histogram[key][index]++
      //       }
      //     }
      //   })
      // })
      if (type === 'result') {
        this.chart = c3.generate({
          bindto: this.$refs.chartContainer,
          ...this.options_bar
        })
        this.$nextTick(() => {
          this.renderCustomLegend()
        })
        // this.handler_bar.$emit('init', this.options_bar)
      } else if (type === 'srgb') {
        this.chart = c3.generate({
          bindto: this.$refs.chartContainer,
          ...this.options_bar_SRGB
        })
        this.$nextTick(() => {
          this.renderCustomLegend()
        })
        // this.handler_bar.$emit('init', this.options_bar_SRGB)
      } else {
        this.chart = c3.generate({
          bindto: this.$refs.chartContainer,
          ...this.options_bar_P3
        })
        this.$nextTick(() => {
          this.renderCustomLegend()
        })
        // this.handler_bar.$emit('init', this.options_bar_P3)
      }
    },
    doSubmit (type) {
      this.loadingView = true
      // this.responseAreaData = [
      //   { errorCode: 'E01', count: 120 },
      //   { errorCode: 'X52', count: 45 },
      //   { errorCode: 'A99', count: 10 },
      //   { errorCode: 'B07', count: 88 }
      // ]
      // this.chart = c3.generate({
      //   bindto: this.$refs.chartContainer,
      //   ...this.options_bar
      // })
      this.$http.post('/api/tpohm/errCountInfo', this.propData).then(res => res.data)
        .then(res => {
          console.info(res)
          this.loadingView = false
          if (res.code === 0) {
            this.responseAreaData = res.data
            this.chart = c3.generate({
              bindto: this.$refs.chartContainer,
              ...this.options_bar
            })
          }
        })
    },
    loadTableData (index, name, value) {
      this.showtable = true
      this.clicktitle = name + '(' + value + ')'
      // var pagingList = [
      //   {
      //     isn: 'ISN12345678',
      //     factoryname: 'PEGA_CQ',
      //     StartTime: '2025-01-10 09:32:11',
      //     EndTime: '2025-01-10 09:35:28',
      //     code90: 'PASS',
      //     modelname: 'ROG_2025_V1',
      //     ToolName: 'LCD_Calibration_Tool',
      //     ToolVer: 'v3.2.1',
      //     ErrorCode: '',
      //     TP_OHM_TEST_Time1: '2.35s',
      //     TP_OHM_TEST1: 152.3,
      //     TP_OHM_TEST_Time2: '2.48s',
      //     TP_OHM_TEST2: 149.8
      //   },
      //   {
      //     isn: 'ISN98765432',
      //     factoryname: 'PEGA_CQ',
      //     StartTime: '2025-01-11 14:21:05',
      //     EndTime: '2025-01-11 14:23:49',
      //     code90: 'FAIL',
      //     modelname: 'ROG_2025_V2',
      //     ToolName: 'LCD_Calibration_Tool',
      //     ToolVer: 'v3.2.1',
      //     ErrorCode: 'E1234',
      //     TP_OHM_TEST_Time1: '2.40s',
      //     TP_OHM_TEST1: 163.2,
      //     TP_OHM_TEST_Time2: '2.52s',
      //     TP_OHM_TEST2: 160.5
      //   }
      // ]
      this.propData.errorCode = name
      this.propData.page = this.pagination.page
      this.propData.size = this.pagination.current.rowsPerPage
      console.info(this.propData)
      this.$http.post('/api/tpohm/lcdCalibrationDataList', this.propData).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.code === 0) {
            this.pagination.current.rowsPerPage = res.data.pageSize
            this.newData = res.data.data
            this.responseData = [...this.newData] // 触发 Vue 响应式更新
            this.pagination.current.totalItems = Number(res.data.totalRecords)
            this.IsSubmitPage = true
          }
          return res
        })
        .then(res => {
          if (res.code === 0) {
            this.pages = res.data.totalPages
            this.IsSubmitPage = false
          }
        })
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
.c3-chart-text {
  font-size: 12px !important; /* 調整數字字體大小 */
}
.app-theme-dark {
  --legend-text-color: #ffffff; /* 白色文字 */
}
.app-theme-light {
  --legend-text-color: #000000; /* 黑色文字 */
}

.legend-item.disabled {
  opacity: 0.5; /* 统一变淡 */
  /* 也可以用 filter 变灰 */
  /* filter: grayscale(100%); */
}

.legend-item.legend-fade:not(.disabled) {
  opacity: 0.3;
}

</style>
